import AddressPhone from "~/components/FooterMaximus/AddressPhone";
import Bottom from "~/components/FooterMaximus/Bottom";
import Contacts from "~/components/FooterMaximus/Contacts";
import Links, { LinksNav } from "~/components/FooterMaximus/Links";
import Logo from "~/components/FooterMaximus/Logo";
import Middle from "~/components/FooterMaximus/Middle";
import NewsletterSignup from "~/components/FooterMaximus/NewsletterSignup";
import PaymentProviders from "~/components/FooterMaximus/PaymentProviders";
import Social from "~/components/FooterMaximus/Social";
import Top from "~/components/FooterMaximus/Top";

const Footer: React.FC = () => (
  <footer
    data-testid="store-footer"
    aria-label="Footer"
    className="print:hidden"
  >
    <Top>
      <PaymentProviders />
      <NewsletterSignup />
    </Top>
    <Middle>
      <Links>
        <LinksNav
          header="Customer Service"
          links={[
            { href: "/users/sign_up", text: "Create An Account" },
            { href: "/order-status", text: "Track Order" },
            { href: "/contact-us", text: "Contact Us" },
            { href: "/shipping-policy", text: "Shipping Policy" },
            { href: "/tax-policy", text: "Tax Policy" },
            { href: "/about-us", text: "About Us" },
            { href: "/charity", text: "Charities We Support" },
            { href: "/faq", text: "FAQ" },
            { href: "/glossary-of-terms", text: "Glossary of Terms" },
            { href: "/returns", text: "Returns" },
            { href: "/privacy-policy", text: "Privacy Policy" },
            {
              href: "/privacy/do-not-sell",
              text: "Do Not Sell/Share My Information",
            },
            { href: "/reviews", text: "ShirtSpace Reviews" },
            { href: "/coupons", text: "ShirtSpace Coupons" },
            { href: "/blog", text: "ShirtSpace Blog" },
            { href: "/videos", text: "ShirtSpace Videos" },
          ]}
        />
        <LinksNav
          header="Popular Brands"
          links={[
            { href: "/gildan", text: "Gildan" },
            { href: "/port-company", text: "Port & Company" },
            { href: "/bella-canvas", text: "Bella + Canvas" },
            { href: "/hanes", text: "Hanes" },
            { href: "/next-level", text: "Next Level" },
            { href: "/comfort-colors", text: "Comfort Colors" },
            { href: "/sport-tek", text: "Sport-Tek" },
            { href: "/fruit-of-the-loom", text: "Fruit of the Loom" },
            { href: "/jerzees", text: "Jerzees" },
            { href: "/brands", text: "» See More" },
          ]}
        />
        <LinksNav
          header="Popular Categories"
          links={[
            { href: "/t-shirts", text: "T-Shirts" },
            { href: "/sweatshirts", text: "Sweatshirts" },
            { href: "/polos", text: "Polos" },
            { href: "/pants", text: "Pants" },
            { href: "/infants-toddlers", text: "Infants & Toddlers" },
            { href: "/athletic-apparel", text: "Athletic Apparel" },
            {
              href: "/tank-tops-sleeveless-shirts",
              text: "Tank Tops & Sleeveless Shirts",
            },
            { href: "/shorts", text: "Shorts" },
            { href: "/categories", text: "» See More" },
          ]}
        />
      </Links>
      <Contacts>
        <Logo />
        <AddressPhone />
        <Social />
      </Contacts>
    </Middle>
    <Bottom />
  </footer>
);

export default Footer;
